<div id="forms" class="page-main-layout" fxLayout="column">

  <!-- HEADER -->
<div class="page-head">
  <div class="bg-card">
    <div class="mx-auto flex w-full max-w-screen-xl flex-col px-2 sm:px-5 md:px-8">
      <div class="my-3 flex min-w-0 flex-auto flex-col sm:my-4 sm:flex-row sm:items-center">
        <div class="flex min-w-0 flex-auto items-center">
          <!-- <div class="h-16 w-16 flex-0 overflow-hidden rounded-full">
            <img src="images/avatars/brian-hughes.jpg" class="h-full w-full object-cover">
          </div> -->
          <div class="relative">
            
          @if(myProfile !== null){
            <div class="h-24 w-24 flex-0 overflow-hidden rounded-full border-2 border-gray-100">
              
              <img
                [src]="myProfile.profileImagePath == '' ? '../images/no-img.jpg' : myProfile.profileImagePath"
                class="h-full w-full object-cover" alt="No Image" />
            </div>
            }
            @if(myProfile === null){
            <div class="h-24 w-24 flex-0 overflow-hidden rounded-full border border-gray-100">
              <img src="../images/no-img.jpg" class="h-full w-full object-cover" alt="No Image"  />
              <!-- <img src="../../../../assets/images/avatars/Velazquez.jpg" class="h-full w-full object-cover" alt="No Image" /> -->
            </div>
            }
            @if(selectedIndex === 1){
            <button mat-icon-button color="primary" class="profile-editbtn absolute top-0 -right-1 h-8 w-8 min-h-8 min-w-8 bg-gray-100" (click)="openModelPopUpCropImage()">
              <mat-icon class="text-white p-2">edit</mat-icon>
            </button>
            }
          </div>
          <div class="ml-4 flex min-w-0 flex-col">
            @if(myProfile !== null){
              <div class="truncate  font-semibold leading-7 tracking-tight md:text-5xl md:leading-snug ng-star-inserted"> 
                {{myProfile.firstName}} {{myProfile.lastName}}
              </div>
              }
            
            <div class="flex items-center">
             <div class="text-secondary ml-1.5 truncate leading-6"> {{userRoleName}} </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <!-- <div class="header profie-header-bg page-head" fxLayout="row" fxLayoutAlign="center center" fxLayout.gt-xs="row"
    fxLayoutAlign.gt-xs="space-between center">
    <div fxLayout="row wrap" class="w-100-p">
      <div fxFlex="50%" fxFlex.xs="100%">
        <div class="d-flex">
          <div class="profile-img-edit">
            @if(myProfile !== null){
            <div class="my-profile-img">
              <img
                [src]="myProfile.profileImagePath === null ? '../../../../assets/images/avatars/Velazquez.jpg' : myProfile.profileImagePath"
                alt="No Image" />
            </div>
            }
            @if(myProfile === null){
            <div class="my-profile-img">
              <img src="../../../../assets/images/avatars/Velazquez.jpg" alt="No Image" />
            </div>
            }
            @if(selectedIndex === 1){
            <button mat-icon-button color="primary" class="profile-editbtn" (click)="openModelPopUpCropImage()">
              <mat-icon>edit</mat-icon>
            </button>
            }
          </div>
          @if(myProfile !== null){
          <div class="my-profile-name align-self-center">
            {{myProfile.firstName}} {{myProfile.lastName}}
          </div>
          }
        </div>
      </div>
    </div>
  </div> -->


  <!-- / HEADER -->
  <!-- CONTENT -->
  <div class="page-content">
 <mat-card class="custom-bg-card px-0 pb-0">
   <mat-tab-group class="edit-profile-tabs" [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event);">
     <mat-tab label="View Profile">
       <div class="tab-content p-0">
         <mat-card class="profile-box  p-0 mb-4 rounded-lg" fxLayout="column">

           <header class="bg-gray-100 p-3 rounded-lg rounded-b-none">
            <p  class="form-title-sm  mb-0"> General Information</p> 
           </header>
           @if(myProfile !==null && myProfile!==undefined){
           <div class="p-4">
             <div fxLayout="row wrap">
               <div fxFlex="50%" fxFlex.xs="100%">
                 <div class="info-line">
                   <div class="title">Name</div>
                   <div class="info"> {{myProfile.firstName}} {{myProfile.lastName}}</div>
                 </div>

                 <div class="info-line">
                   <div class="title">Email</div>
                   <div class="info">{{myProfile.email}}</div>
                 </div>
                 @if(myProfile.phoneNumber !== null && myProfile.myProfileAddressModel !== undefined){
                 <div class="info-line">
                   <div class="title">Phone Number</div>
                   <div class="info">{{myProfile.phoneNumber}}</div>
                 </div>
                 }
                 @if(myProfile.extPhoneNumber !== null && myProfile.myProfileAddressModel !== undefined){
                 <div class="info-line">
                   <div class="title">Ext</div>
                   <div class="info">{{myProfile.extPhoneNumber}}</div>
                 </div>
                 }


               </div>
               <div fxFlex="50%" fxFlex.xs="100%">
               </div>
             </div>
           </div>
           }

         </mat-card>
       </div>
     </mat-tab>
     <mat-tab label="Edit Profile">
       <div class="tab-content p-0">
         <mat-card class="profile-box  p-0 mb-4 rounded-lg" fxLayout="column">
           <header class="bg-gray-100 p-3 rounded-lg rounded-b-none">
            <p  class="form-title-sm  mb-0"> Email : {{myProfile === null ? '-':myProfile.email}}</p>
           </header>

           <div class="p-4">
             <div class="">
               <div>
                 <form class="" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="editProfileForm"
                   [formGroup]="editProfileForm" (submit)="onSubmit()" novalidate>
                   @if(apiResponseErrorMessage!=null){
                   <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                     <div fxFlex="100" class="mb-4">
                       <div class="message-box error">
                         {{apiResponseErrorMessage}}
                       </div>
                     </div>
                   </div>
                   }
                   <div fxLayout="row wrap" class="r-row gap-x-3 gap-y-0 sm:gap-6">
                     <div fxFlex="auto" fxFlex.xs="100">
                       <div class="px-1rem">
                         <mat-form-field class="w-100-p">
                          <mat-label>First Name</mat-label>
                           <input matInput placeholder="First Name" formControlName="firstName" required>
                           @if(editProfileForm.get('firstName').hasError('required')){
                           <mat-error>
                             First Name is required.
                           </mat-error>
                           }
                           @if(!editProfileForm.get('firstName').hasError('required') &&
                           (editProfileForm.get('firstName').hasError('minlength') ||
                           editProfileForm.get('firstName').hasError('maxlength') ||
                           editProfileForm.get('firstName').hasError('whitespace'))){
                           <mat-error>
                             Length must be between 2 and auto.
                           </mat-error>
                           }
                         </mat-form-field>
                       </div>
                     </div>
                     <div fxFlex="auto" fxFlex.xs="100">
                       <div class="px-1rem">
                         <mat-form-field class="w-100-p">
                          <mat-label>Last Name</mat-label>
                           <input matInput placeholder="Last Name" formControlName="lastName" required>
                           @if(editProfileForm.get('lastName').hasError('required')){
                           <mat-error>
                             Last Name is required.
                           </mat-error>
                           }
                           @if(!editProfileForm.get('lastName').hasError('required') &&
                           (editProfileForm.get('lastName').hasError('minlength') ||
                           editProfileForm.get('firstName').hasError('maxlength') ||
                           editProfileForm.get('lastName').hasError('whitespace'))){
                           <mat-error>
                             Length must be between 2 and 50.
                           </mat-error>
                           }
                         </mat-form-field>
                       </div>
                     </div>
                   </div>

                   <div fxLayout="row wrap" class="r-row gap-x-3 gap-y-0 sm:gap-6">
                     <div fxFlex="auto" fxFlex.xs="100%">
                       <div class="px-1rem">
                         <mat-form-field class="w-100pr">
                          <mat-label>Street</mat-label>
                           <input matInput placeholder="Street" formControlName="street" required>
                           @if(editProfileForm.get('street').hasError('required')){
                           <mat-error>
                             Street is required.
                           </mat-error>
                           }
                           @if(!editProfileForm.get('street').hasError('required') &&
                           (editProfileForm.get('street').hasError('minlength') ||
                           editProfileForm.get('street').hasError('maxlength') ||
                           editProfileForm.get('street').hasError('whitespace'))){
                           <mat-error>
                             Length must be between 2 and 100
                           </mat-error>
                           }
                         </mat-form-field>
                       </div>
                     </div>
                     <div fxFlex="auto" fxFlex.xs="100%">
                       <div class="px-1rem">
                        <mat-label>Country<span class="required">*</span></mat-label>
                         <country-dropdown (valueChange)='onChangeCountry($event)' [value]="selectedCountryName"
                           [isRequired]="true"></country-dropdown>
                           
                         <!--<mat-form-field class="w-100pr">
                             <input matInput placeholder="Country" formControlName="country" required>
                             <mat-error *ngIf="editProfileForm.get('country').hasError('required')">
                               Country is required.
                             </mat-error>
                             <mat-error *ngIf="!editProfileForm.get('country').hasError('required') && (editProfileForm.get('country').hasError('minlength')  || editProfileForm.get('country').hasError('maxlength') || editProfileForm.get('country').hasError('whitespace'))">
                               Length must be between 2 and 50
                             </mat-error>
                           </mat-form-field>-->
                       </div>
                     </div>
                     <div fxFlex="auto" fxFlex.xs="100%">
                       <div class="px-1rem">
                         <!--<mat-form-field class="w-100pr">
                             <input matInput placeholder="State" formControlName="state" required>
                             <mat-error *ngIf="editProfileForm.get('state').hasError('required')">
                               State is required.
                             </mat-error>
                             <mat-error *ngIf="!editProfileForm.get('state').hasError('required') && (editProfileForm.get('state').hasError('minlength') || editProfileForm.get('state').hasError('maxlength') || editProfileForm.get('state').hasError('whitespace'))">
                               Length must be between 2 and 50
                             </mat-error>
                           </mat-form-field>-->
                           <mat-label>State<span class="required">*</span></mat-label>
                         <state-dropdown [countryId]="selectedCountryDropdown.value" [value]="selectedStateName"
                           (valueChange)='onChangeState($event)' [isRequired]="true"></state-dropdown>
                       </div>
                     </div>
                   </div>

                   <div fxLayout="row wrap" class="r-row gap-x-3 gap-y-0 sm:gap-6">
                     <div fxFlex="auto" fxFlex.xs="100%">
                       <div class="px-1rem">
                         <mat-form-field class="w-100pr">
                          <mat-label>City</mat-label>
                           <input matInput placeholder="City" formControlName="city" required>
                           @if(editProfileForm.get('city').hasError('required')){
                           <mat-error>
                             City is required.
                           </mat-error>
                           }
                           @if(!editProfileForm.get('city').hasError('required') &&
                           (editProfileForm.get('city').hasError('minlength') ||
                           editProfileForm.get('city').hasError('maxlength')||
                           editProfileForm.get('city').hasError('whitespace'))){
                           <mat-error>
                             Length must be between 2 and 50
                           </mat-error>
                           }
                         </mat-form-field>
                       </div>
                     </div>
                     <div fxFlex="auto" fxFlex.xs="100%">
                       <div class="px-1rem">
                         <mat-form-field class="w-100pr">
                          <mat-label>Zip Code</mat-label>
                           <input matInput placeholder="Zip Code" formControlName="zipCode" required>
                           @if(editProfileForm.get('zipCode').hasError('required')){
                           <mat-error>
                             Zip Code is required.
                           </mat-error>
                           }
                           @if(!editProfileForm.get('zipCode').hasError('required') &&
                           (editProfileForm.get('zipCode').hasError('minlength') ||
                           editProfileForm.get('zipCode').hasError('maxlength')||
                           editProfileForm.get('zipCode').hasError('whitespace'))){
                           <mat-error>
                             Length must be between 5 to 6.
                           </mat-error>
                           }
                         </mat-form-field>
                       </div>
                     </div>
                   </div>

                   <div fxLayout="row wrap" class="r-row gap-x-3 gap-y-0 sm:gap-6">

                     <div fxFlex="auto" fxFlex.xs="100%">
                       <div class="px-1rem">
                         <mat-form-field class="w-full">
                           <mat-label>Contact</mat-label>
                           <input matInput 
                           id="contact"
                           placeholder="Phone Number(xxx-xxx-xxxx)" (input)="formatPhoneNumber($event)" maxlength="12" 
                           [formControlName]="'phoneNumber'" 
                           required />
                           @if (editProfileForm.get('phoneNumber').hasError('required')) {
                               <mat-error> Phone Number is required. </mat-error>
                           }
                           @if (!editProfileForm.get('phoneNumber').hasError('required') && editProfileForm.get('phoneNumber').hasError('phoneNumberValidator')) {
                               <mat-error> Invalid Contact Number. </mat-error>
                           }
                       </mat-form-field>
                       </div>
                     </div>
                     <div fxFlex="auto" fxFlex.xs="100%">
                       <div class="px-1rem">
                         <mat-form-field fxFlex="100">
                          <mat-label>Ext</mat-label>
                           <input matInput placeholder="Ext" formControlName="extPhoneNumber">
                           @if(editProfileForm.get('extPhoneNumber').hasError('invalidExtPhoneNumber')){
                           <mat-error>
                             Ext must be numeric and allow only 4 digit.
                           </mat-error>
                           }
                         </mat-form-field>
                       </div>
                     </div>
                   </div>
                   <div class="pt-3 gap-3" fxLayout="row" fxLayoutAlign="end center">
                     <button mat-raised-button type="submit" color="primary"
                       [disabled]="!editProfileForm.valid||isSubmitEditProfileBtnDisabled">
                       Save
                     </button>
                     <button type="button" mat-button color="warn" (click)="onCancel()">Cancel</button>
                   </div>
                 </form>
                 <!-- / REACTIVE FORM EXAMPLE -->
               </div>
             </div>
           </div>

         </mat-card>
       </div>

     </mat-tab>
     <mat-tab label="Change Password">
       <div class="tab-content p-0">
         <mat-card class="profile-box  p-0 mb-4 rounded-lg" fxLayout="column">
           <header class="bg-gray-100 p-3 rounded-lg rounded-b-none">
            <p  class="form-title-sm mb-0"> Change Password</p>
           </header>
           <div class="p-4">
             <div class="">
               <div>
                 <form class="" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="frmChangePassword"
                   [formGroup]="frmChangePassword" (submit)="onSubmitChangePassword();" novalidate>
                   @if(apiResponseErrorMessageChangePassword!=null){
                   <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                     <div fxFlex="100" class="mb-4">
                       <div class="message-box error">
                         {{apiResponseErrorMessageChangePassword}}
                       </div>
                     </div>
                   </div>
                   }

                   <mat-form-field class="w-100-p">
                    <mat-label>Enter Current Password</mat-label>
                     <input type="password" matInput placeholder="Enter Current Password" parent="true" required
                       color="primary" formControlName="currentPassword">
                   </mat-form-field>
                   @if(frmChangePassword.get('currentPassword').dirty){
                   <mat-error class="hint-section">
                     @if(frmChangePassword.get('currentPassword').hasError('required')){
                     <span>Current Password is required</span>
                     }
                   </mat-error>
                   }

                   <mat-form-field class="w-100-p">
                    <mat-label>Enter New Password</mat-label>
                     <input type="password" matInput placeholder="Enter New Password" required color="primary"
                       formControlName="newPassword">
                     @if(frmChangePassword.get('newPassword').dirty){
                     <mat-error>
                       @if(frmChangePassword.get('newPassword').hasError('required')){
                       <span>New Password is required</span>
                       }
                       @if(!frmChangePassword.get('newPassword').hasError('required') &&
                       frmChangePassword.get('newPassword').hasError('invalidPassword')){
                       <span>
                         Minimum 6 characters,and combination of Alphanumeric and special character.
                       </span>
                       }
                     </mat-error>
                     }
                   </mat-form-field>

                   <mat-form-field class="w-100-p">
                    <mat-label>Enter Confirm Password</mat-label>
                     <input type="password" matInput placeholder="Enter Confirm Password" required color="primary"
                       formControlName="confirmPassword">
                     <mat-error>
                       @if(frmChangePassword.get('confirmPassword').hasError('required')){
                       <span>Confirm Password is required</span>
                       }
                       @if(!frmChangePassword.get('confirmPassword').hasError('required') &&
                       frmChangePassword.get('confirmPassword').hasError('passwordsNotMatching')){
                       <span>
                         Passwords and Confirm Password are not same.
                       </span>
                       }
                     </mat-error>
                   </mat-form-field>


                   <div class="pt-3" fxLayout="row" fxLayoutAlign="end center">
                     <button mat-raised-button type="submit" color="primary"
                       [disabled]="!frmChangePassword.valid||isSubmitChangePasswordBtnDisabled">
                       Change Password
                     </button>
                   </div>
                 </form>
                 <!-- / REACTIVE FORM EXAMPLE -->
               </div>
             </div>
           </div>
         </mat-card>
       </div>
     </mat-tab>
     @if(isClientAdmin){
     <mat-tab label="{{tabTitleLable}}">
       <div class="tab-content">
         <mat-card class="profile-box  p-0 mb-4 rounded-lg" fxLayout="column">
           <header class="bg-gray-100 p-3 rounded-lg rounded-b-none">
            <p  class="form-title-sm mb-0">  {{tabTitleLable}}</p>
             
           </header>
           <div class="p-4">
             <div class="">
               <div>
                 <form class="" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="frmSetOrChangeCompanyCode"
                   [formGroup]="frmSetOrChangeCompanyCode" (submit)="onSubmitSetOrChangeCompanyCode()" novalidate>
                   @if(apiResponseErrorMessageChangeSecurityCode!=null){
                   <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                     <div fxFlex="100" class="mb-4">
                       <div class="message-box error">
                         {{apiResponseErrorMessageChangeSecurityCode}}
                       </div>
                     </div>
                   </div>
                   }

                  @if(isSetCompanyCode){
                   <mat-form-field class="w-100-p">
                    <mat-label>Current Code</mat-label>
                     <input type="password" matInput placeholder="Enter {{companyCodeLabel.CurrentCode}}" required
                       color="primary" formControlName="currentCode">
                     <mat-error>
                       @if(frmSetOrChangeCompanyCode.get('currentCode').hasError('required')){
                       <span>{{companyCodeLabel.CurrentCode}} is required.</span>
                       }
                       @if(!frmSetOrChangeCompanyCode.get('currentCode').hasError('required') &&
                       frmSetOrChangeCompanyCode.get('currentCode').hasError('maxlength')){
                       <span>
                         Maximum 4 digit allowed.
                       </span>
                       }
                     </mat-error>
                   </mat-form-field>
                  }

                   <!-- @if(isSetCompanyCode){
                   <mat-form-field class="w-100-p">
                    <mat-label>Current Code</mat-label>
                     <input type="password" matInput placeholder="Enter {{companyCodeLabel.CurrentCode}}" parent="true"
                       color="primary" formControlName="currentCode">
                   </mat-form-field>
                   }
                   @if(isSetCompanyCode){
                   <mat-error class="error_class">
                     @if(frmSetOrChangeCompanyCode.get('currentCode').hasError('required')){
                     <span>{{companyCodeLabel.CurrentCode}} is required.</span>
                     }
                     @if(!frmSetOrChangeCompanyCode.get('currentCode').hasError('required') &&
                     frmSetOrChangeCompanyCode.get('currentCode').hasError('maxlength')){
                     <span>
                       Maximum 4 digit allowed.
                     </span>
                     }
                   </mat-error>
                   } -->

                   <mat-form-field class="w-100-p">
                    <mat-label>New Company Code</mat-label>
                     <input type="password" matInput placeholder="Enter {{companyCodeLabel.NewCode}}" required
                       color="primary" formControlName="newCode">
                     <mat-error>
                       @if(frmSetOrChangeCompanyCode.get('newCode').hasError('required')){
                       <span>{{companyCodeLabel.NewCode}} is required.</span>
                       }
                       @if(!frmSetOrChangeCompanyCode.get('newCode').hasError('required') &&
                       frmSetOrChangeCompanyCode.get('newCode').hasError('maxlength')){
                       <span>
                         Maximum 4 digit allowed.
                       </span>
                       }
                     </mat-error>
                   </mat-form-field>

                   <mat-form-field class="w-100-p">
                    <mat-label>Confirm Company Code</mat-label>
                     <input type="password" matInput placeholder="Enter {{companyCodeLabel.ConfirmCode}}" required
                       color="primary" formControlName="confirmCode">
                     <mat-error>
                       @if(frmSetOrChangeCompanyCode.get('confirmCode').hasError('required')){
                       <span>{{companyCodeLabel.ConfirmCode}} is required.</span>
                       }
                       @if(!frmSetOrChangeCompanyCode.get('confirmCode').hasError('required') &&
                       frmSetOrChangeCompanyCode.get('confirmCode').hasError('codeNotMatching')){
                       <span>
                         {{companyCodeLabel.NewCode}} and {{companyCodeLabel.ConfirmCode}} are not same.
                       </span>
                       }
                     </mat-error>
                   </mat-form-field>
                   <div class="pt-3" fxLayout="row" fxLayoutAlign="end center">
                     <button mat-raised-button type="submit" color="primary"
                       [disabled]="!frmSetOrChangeCompanyCode.valid">
                       {{tabTitleLable}}
                     </button>
                   </div>
                 </form>
                 <!-- / REACTIVE FORM EXAMPLE -->
               </div>
             </div>
           </div>
         </mat-card>
       </div>
     </mat-tab>
     }
   </mat-tab-group>
 </mat-card>

  </div>
  <!-- / CONTENT -->
</div>